import client from './graphQlClient';
import { SEARCH_CHARTERERS } from './queries/CompanyQueries';
export class CharterersApi {
    static search = (name, cancelToken) => {
        return new Promise((resolve, reject) => {
            client()
                .query({
                    query: SEARCH_CHARTERERS,
                    fetchPolicy: 'no-cache',
                    variables: {
                        search: name,
                    },
                })
                .then((result) => {
                    resolve(result.data.charterers);
                });
            cancelToken.promise.then((reason) => {
                reject(reason);
            });
        });
    };
}
